import React from "react";
import { observer } from "mobx-react";
import { Period } from "@state/common/PeriodConverter";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";

import { FavoritesMenuItem } from ".";

export type store = {
	isOfferMenuOpen: boolean;
	toggleUpdateProcessing: PrematchOfferMenuStore["toggleUpdateProcessing"];
	periodSubMenu: {
		isPeriodMenuExpanded: boolean;
		setPeriodKey: (p: Period) => void;
		periodMenu: { period: Period; name: string }[];
		selectedPeriodKey: Period;
	};
	isEmpty: boolean;
	isLoading: boolean;
	selectedSport: PrematchOfferMenuStore["selectedSport"];
	menu: PrematchOfferMenuStore["menu"];
	isFavoritesSubMenuOpen: boolean;
};

export const FavoritesMenuItems = observer(function FavoritesMenuItems(props: {
	store: store;
}) {
	return (
		<nav className="nav--tertiary">
			<ul className="nav--tertiary__menu">
				<FavoritesMenuItem store={props.store} />
			</ul>
		</nav>
	);
});
